import { Button, Card, Chip, Typography } from '@mui/material';
import Grid from '@mui/material/Grid';
import React from 'react';
import { NavLink } from 'react-router-dom';

interface AssessmentGradingStatusCardProps {
  title: string;
  assessmentId: string | undefined;
  isGraded: boolean;
  isComplete: boolean;
  jobId: string | undefined;
  applicantId: string | undefined;
  isOptional?: boolean | number;
}

const AssessmentGradingStatusCard: React.FC<
  AssessmentGradingStatusCardProps
> = ({ title, assessmentId, isGraded, jobId, applicantId, isComplete, isOptional }) => {
  return (
    <Card
      sx={{ mb: 4, width: '100%', padding: '10px 15px' }}
      className="assessment-card"
    >
      <Grid container direction="row" alignItems="center" justifyItems="center">
        <Grid container xs={8} md={8} item direction="row">
          <Grid item>
            <Typography
              variant="h6"
              sx={{ textAlign: 'left', fontWeight: 'bold' }}
            >
              {title}
            </Typography>
          </Grid>
          {isOptional ? (
            <Grid item sx={{ ml: 2, mt: '4px' }}>
              <Chip size="small" label="Optional" color="default" />
            </Grid>
          ) : null}
        </Grid>
        <Grid item container xs={4} md={4} justifyContent="flex-end">
          {isComplete ? (
            isGraded ? (
              <NavLink
                  to={`/grade-assessment/job/${jobId}/applicant/${applicantId}/assessment/${assessmentId}?view=true`}
                >
              <Button
                className="viewDetailsButton"
                variant="contained"
                sx={{
                  backgroundColor: 'var(--ttg-green)',
                  '&:hover': {
                    backgroundColor: 'var(--ttg-green)',
                  },
                  marginTop: '20px',
                  padding: '10px 20px',
                  //cursor: 'default',
                }}
              >
                {'View Results'}
              </Button>
             </NavLink>
            ) : (
              <NavLink
                to={`/grade-assessment/job/${jobId}/applicant/${applicantId}/assessment/${assessmentId}`}
              >
                <Button
                  className="viewDetailsButton"
                  variant="contained"
                  sx={{
                    backgroundColor: 'var(--ttg-black)',
                    '&:hover': {
                      backgroundColor: 'var(--ttg-green)',
                    },
                    marginTop: '20px',
                    padding: '10px 20px',
                  }}
                >
                  {'Continue Grading'}
                </Button>
              </NavLink>
            )
          ) : (
            <Button
              className="viewDetailsButton"
              variant="contained"
              sx={{
                backgroundColor: 'var(--ttg-black)',
                '&:hover': {
                  backgroundColor: 'var(--ttg-green)',
                },
                marginTop: '20px',
                padding: '10px 20px',
              }}
            >
              {'Not Submitted'}
            </Button>
          )}
        </Grid>
      </Grid>
    </Card>
  );
};

export default AssessmentGradingStatusCard;
export { AssessmentGradingStatusCardProps };
